import { useState } from 'react';

// styles
import {
  Video,
  VideoLink,
  VideoTitle,
  VideoPlay,
  VideoFrame,
} from './Team.styles';

// A thumbnail link that swaps for the YouTube player when clicked. Without
// JavaScript it is a plain link to the video.
export function VideoFacade({ video }) {
  const [playing, setPlaying] = useState(false);

  return (
    <Video>
      {playing ? (
        <VideoFrame
          src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0`}
          title={video.title}
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <VideoLink
          href={video.url}
          aria-label={`Watch video: ${video.title}`}
          onClick={(event) => {
            event.preventDefault();
            setPlaying(true);
          }}
        >
          <img
            src={video.poster}
            alt=""
            width="480"
            height="360"
            loading="lazy"
          />
          <VideoTitle>{video.title}</VideoTitle>
          <VideoPlay aria-hidden="true" />
        </VideoLink>
      )}
    </Video>
  );
}
